import { gql } from 'graphql-request';

export const GET_CESSION_DOCUMENT_SCHEME = gql`
  query App1d1b2841_Document($documentId: String) {
    app1d1b2841_Document {
      getTemplate(documentId: $documentId) {
        template {
          step
          name
          type
          value
          required
          isSearchable
          placeholder
          fieldTransform
          fieldType
          label {
            en
            ru
          }
          stepLabel
          validation
          options {
            label
            value
          }
        }
      }
    }
  }
`;
